import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Shared centered loading indicator for page-level fetches.
 */
const LoadingState = ({ label = 'Loading…', minHeight = '60vh' }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      justifyContent: 'center',
      alignItems: 'center',
      minHeight,
    }}
  >
    <CircularProgress size={36} thickness={4} />
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
  </Box>
);

export default LoadingState;
